import { color } from "@mui/system";
import React, { useRef, useState, useEffect } from "react";
import SparklyBorder from "../SparklyBorders/SparklyBorderWithoutSVG";

export default function UltraLuxInput({
  label = "Customer Name",
  type="text",
  value,
  onChange,
  list = "list_customer",
  labelDisplacement,
  disabled = false,
  labelWidth,
  labelHeight,
  borderWidth,
  borderHeight,
  inputWidth,
  inputHeight,
  translateXLabel,
  translateYLabel,
  translateXInput,
  translateYInput,
}) {
  const [focused, setFocused] = useState(false);
  const [hovered, setHovered] = useState(false);
  const inputRef = useRef(null);

  const [size, setSize] = useState({ width: 0, height: 0 });
  const [borderSize, setBorderSize] = useState({ width: inputWidth, height: inputHeight });

  const [inputSize, setInputSize] = useState({ width: inputWidth, height: inputHeight });


useEffect(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
     // setBorderSize({ width: rect.width, height: rect.height });
      setBorderSize({ width: inputWidth, height: inputHeight });

    setInputSize({ width: inputWidth, height: inputHeight });

    }
  }, [inputWidth, inputHeight]);

  useEffect(() => {

    setInputSize({ width: inputWidth, height: inputHeight });
  }, [inputWidth, inputHeight]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (inputRef.current) {
        setBorderSize({
          width: inputRef.current.offsetWidth,
          height: inputRef.current.offsetHeight,
        });
      }
    });
  }, []);
  
  
  


  return (
    <div style={{ 
      position: "relative", 
      justifyContent:"center",
      alignItems:"center",
      padding: ".1vw 0" 
      }}>
      <style>{`
        @keyframes shimmerFlow {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        @keyframes fadeSlideUp {
          0% { opacity: 0; transform: translateY(20px) scale(0.98); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }

        @keyframes blinkText {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes orbit {
          0% { transform: rotate(0deg) translateX(7vw) rotate(0deg); }
          100% { transform: rotate(360deg) translateX(7vw) rotate(-360deg); }
        }

        @keyframes borderFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes sparkRun {
          0%   { top: 22%; left: 0; }
          25%  { top: 22%; left: 75%; transform: translateX(-90%); }
          50%  { top: 70%; left: 75%; transform: translate(-90%, -80%); }
          75%  { top: 70%; left: 0; transform: translateY(-60%); }
          100% { top: 22%; left: 0; }
        }

        @keyframes sparkleTwinkle {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.5); opacity: 0.8; filter: blur(1px); }
          100% { transform: scale(1); opacity: 1; filter: blur(0.3px); }
        }

        
        .lux_input {


          font-weight: normal;
          color: #000;
          background: rgba(255, 255, 255, 0.8);

          
          border: none;
          border-radius: 1vw;
          outline: none;
          backdrop-filter: blur(14px);
          transition: all 0.4s ease;
          animation: fadeSlideUp 1s ease;
          box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.05),
                      0 0 25px rgba(255, 105, 180, 0.15);

        }

        .lux_input:hover {
          border-color: rgba(255, 182, 193, 0.5);
          box-shadow: 0 0 25px rgba(255, 20, 147, 0.3),
                      inset 0 0 15px rgba(255, 255, 255, 0.1);
        }

        .lux_input:focus {
          border-color: #ff69b4;
          box-shadow: 0 0 35px rgba(255, 105, 180, 0.6),
                      inset 0 0 20px rgba(255, 255, 255, 0.2);
          background: rgba(255, 230, 240, 0.6);


        }

        .lux_label {
          position: absolute;
          left: 50%;
          top: 50%;

          color: #ffffff;
          font-size: 1.5vw;
          font-weight: 800;
          pointer-events: none;
          transition: all 0.5s ease-in-out;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1)
          );

          animation: shimmerFlow 9s linear infinite;
          z-index: 5;
        }
        
        .lux_label.active {
          top: 50%; /* keep same vertical alignment */
     

          font-size: .5vw;
          color: #847f81;

          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1)
          );
          
          background-size: 100% auto;

        }


        
        .lux_input:disabled {
          opacity: 0.5;
          filter: grayscale(60%);
          cursor: not-allowed;
          box-shadow: none;
        }
      `}</style>

      <div
        style={{

        }}
      >

        <label
          className={`lux_label ${focused || value ? "active" : ""
            }`}
          style={{
            fontSize: focused || value ? "1.5vh" : "1.5vh",
            fontWeight: focused || value ? "1800" : "bold",
            textAlign: "right",
            width: focused || value ? inputSize.width * .4 : inputSize.width * .4,
            height: inputSize.height,
            color: focused || value ? "#000000" : "transparent",
            borderRadius: ".1vw",
            transform: focused || value
            ? `translate(${labelDisplacement}, ${translateYLabel})`
            : `translate(${translateXLabel}, ${translateYLabel})`,
            // border: focused || value ? "0.05vw solid #ff69b4" : " ",
            boxShadow: focused || value ? "2vw solid #000000" : " ",

            background: focused || value
              ? "rgba(255, 230, 240, 0)"
              : "transparent", // ✅ white background when inside
            animation: focused ? (value ? "none" : "blinkText 1s infinite") : "none", // ✨ blinking effect

          }}
        >
          {label}


        </label>

      </div>



      <div
        style={{
          position: "relative",
          display: "inline-block",

        }}
      >
        <input
             // ⬅️ prevents forced height
          style={{
             borderRadius:"6px",
             width: inputSize.width,
             height: inputSize.height,
             paddingLeft:".5vw",
             transform: `translate(${translateXInput}, ${translateYInput})`,
             fontSize: ".7vw",
             zIndex:"600",
          }}
          placeholder=""
          ref={inputRef}
          type={type}
          className="lux_input"
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          list={list}
          disabled={disabled}

        />

        {
          focused &&
          (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none",
                transform: `translate(${translateXInput}, 0%)`
              }}
            >
              <SparklyBorder
                width={borderSize.width}
                height={borderSize.height}
                radius={6}
                speed={65}
              />
            </div>
          )}



      </div>



    </div>
  );
}
